import styled from 'styled-components';
import { layout, space } from 'styled-system';

export const StyledTooltip = styled.span`
  display: inline-block;
  position: relative;

  ${space}
  ${layout}
`;
